import { render } from "./main-cart.vue?vue&type=template&id=27ac3713"
import script from "./main-cart.vue?vue&type=script&lang=js"
export * from "./main-cart.vue?vue&type=script&lang=js"

import "./main-cart.vue?vue&type=style&index=0&id=27ac3713&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__